export default [
  {
    date: '2025-03-01',
    title: 'Wizard AI is here !!!',
    features: [
      'Our first of many AI-generated features has been released to automate your workflow.',
      'Let Wizard AI calibrate floor plans for you.',
      'Coming Soon: AI-generated space type detection, seat counts, and measured USF.',
      'Don’t see this functionality in your company’s account? Contact your org admin.',
    ],
  },
  {
    date: '2025-02-01',
    title: 'Check out our updated User Guides.',
    features: [
      'Click on the help icon (which appears as a question mark) in the top navigation header to access the updated user guides.',
      'Guides include: project type overview, floor plan upload tips, and mobile app FAQs.',
    ],
  },
  {
    date: '2025-01-01',
    title: 'Undo and Redo are now available within your measuring toolbar.',
    features: [
      'Undo and redo while in measure mode.',
      'Switch between draw, rotate, scale, and delete while applying undo and redo.',
      'Leverage keyboard shortcuts Ctrl+Z to undo and Ctrl+Shift+Z to redo your most recent actions.',
    ],
  },
  {
    date: '2024-12-02',
    title:
      'Explore the new Programming worksheet design to manage space types.',
    features: [
      'Show, hide, and delete functionality has moved into the updated Manage Space Types pop-up.',
      'Show all and hide all space types faster on worksheets with the new pop-up.',
      'Create and rename space types from this new pop-up as well.',
    ],
  },
  {
    date: '2024-12-01',
    title: 'Don’t forget to round your Programming worksheet quantities!',
    features: [
      'Converting headcount to work seats often generates fractional seat count.',
      'Applying target ratios and seat % mix also tends to yield fractional quantities per space type.',
      'Any quantity in red is not a whole number.',
      'Click into any quantity field outlined in red to round up or round down that space type.',
    ],
  },
  {
    date: '2024-11-02',
    title:
      'Resize measured shapes and floors with the scaling tool found in the measuring tool bar.',
    features: [
      'Retain the measured USF of spaces and floors when replacing floor plans with the new scaling tool.',
      'Use the scaling tool to resize measured spaces and measured floors when copying to the same floor and also to other floors.',
    ],
  },
  {
    date: '2024-11-01',
    title:
      'Copy measured shapes in addition to the corresponding space bubble on floor plans.',
    features: [
      'Measured shapes now copy in addition to any other data associated with a space bubble.',
      'Leverage the View USF filter to reveal which space bubbles have a measured shape associated with them.',
    ],
  },
  {
    date: '2024-10-02',
    title:
      'Select your preferred Units of Measurement with the new FT and M toggle.',
    features: [
      'View and edit project data in SQ FT or SQ M.',
      'Switch the measurement toggle back and forth when viewing or editing project data and watch all values instantly convert.',
      'Values in exported files reflect the selected units of measurement setting.',
    ],
  },
  {
    date: '2024-10-01',
    title:
      'Manually resolve Missing Data to remove red warnings in Benchmark Projects.',
    features: [
      'Missing Data can be manually dismissed and marked as resolved (instead of fixed) in order to intentionally leave specific data fields blank.',
      'A record of manually resolved Missing Data can be found in the Resolved tab in order to revert any decisions as needed.',
    ],
  },
  {
    date: '2024-09-01',
    title:
      'New export options for your Programming dashboards are now available.',
    features: [
      'Find several new options under the Download button on your Program Summary page.',
      'Export Program Summary cards one at a time or all at once.',
      'Metrics can also be exported by space category.',
    ],
  },
  {
    date: '2024-08-01',
    title:
      'Paste multiple copies of space bubbles with the new stamping feature.',
    features: [
      'While in copy mode, paste the same group of space bubbles multiple times to more quickly tag your floor plans.',
      'Discover new keyboard shortcuts including Ctrl+V and Alt+Drag to leverage this feature.',
    ],
  },
  {
    date: '2024-07-02',
    title:
      'Count spaces as Alternative Workpoints when they serve multiple functions.',
    features: [
      'Go to Project Profile and include or exclude Individual Workspaces as traditional work seats.',
      'Edit Meeting, Amenity, or Support space bubbles from your floor plans and assign any of them as alternative workpoints.',
    ],
  },
  {
    date: '2024-07-01',
    title:
      'New export options for your Existing Site Analysis dashboards are now available.',
    features: [
      'Find several new options under the Download button on your Program Summary page.',
      'Export Program Summary cards one at a time or all at once.',
      'Metrics can also be exported by space category.',
    ],
  },
  {
    date: '2024-06-01',
    title:
      'Link your projects tagged Benchmark to create instant Benchmark Reports!',
    features: [
      'Exciting new Project Search parameters are available to find the projects you want.',
      'Link your projects based on Location, Size, Client, Industry, and more ...',
      'Create instant one-page dashboards which can be exported as PNGs or a PDF. ',
      'Review any Missing Project Data to ensure that your linked projects are generating the most accurate Benchmark Report metrics.',
    ],
  },
  {
    date: '2024-05-02',
    title:
      'Total RSF per floor has been added as an input field in addition to rentable load factor.',
    features: [
      'Total RSF can be entered for the floor if the rentable load factor is unknown.',
      'When updates are made to the Total USF on a floor, decide which RSF value (rentable load factor % or Total RSF) to hold in place and the other value will recalculate.',
    ],
  },
  {
    date: '2024-05-01',
    title:
      'Building headcount is now an option when floor headcount is unknown.',
    features: [
      'When floor headcount is unknown, headcount can be entered for the building instead in the updated Headcount page.',
      'Use either the headcount values determined by the Architect or the values provided by the Client for summary report metrics.',
    ],
  },
  {
    date: '2024-04-01',
    title: 'Object Snap is now available for most PDF floor plans!',
    features: [
      'Measure faster and with greater accuracy on any floor plan that qualifies for snapping.',
      'PNGs and JPEGs do not qualify. PDFs without the proper underlying data also do not qualify.',
      'The new Object Snap status button will alert you when snapping is unavailable on a floor.',
    ],
  },
  {
    date: '2024-03-02',
    title:
      'Project location fields have been enhanced to autocomplete for you.',
    features: [
      'Select from the pre-loaded cities listed on both the project level and for each building.',
      'International locations are supported as well.',
    ],
  },
  {
    date: '2024-03-01',
    title:
      'New optional data fields are available for Existing Site Analysis projects.',
    features: [
      'Enter the Project Start Year and Client Move-In Year if those fields are known.',
      'Select whether or not the location is the headquarters in that Client’s real estate portfolio.',
    ],
  },
  {
    date: '2024-02-02',
    title:
      'Floor plans with tagged spaces can now be exported as PNG files per floor.',
    features: [
      'Download floor plans with space bubbles showing based on the view that you turn on per floor.',
      'Experiment by turning filters on and off to select the desired view to export.',
    ],
  },
  {
    date: '2024-02-01',
    title: 'Apply client facing names to any space type on your floor plans.',
    features: [
      'Keep internal names for consistent data across projects but use client names to rename space types when needed per project.',
      'This new Client Names toggle allows you to view and export with either space type name.',
    ],
  },
  {
    date: '2024-01-02',
    title:
      'Reassign space types to different space categories on your floor plans.',
    features: [
      'When necessary, space types can be moved from one space category to another.',
      'Since comparable data across projects is important in order to compare data, use this functionality sparingly.',
    ],
  },
  {
    date: '2024-01-01',
    title:
      'A new file type is now available when exporting Programming worksheets.',
    features: [
      'Download worksheets per program scenario from Programming projects as spreadsheets.',
      'Exported XLSX files include two tabs with headcount and worksheet values as raw data.',
    ],
  },
  {
    date: '2023-12-02',
    title:
      'Add a Custom Subcategory to Individual Workspaces on your floor plans.',
    features: [
      'If Workstations and Private Offices are not your only two subcategories, add a third subcategory for flex seats and other work points!',
      'Create and edit this subcategory from your floor plan worksheets or in the Project Profile.',
    ],
  },
  {
    date: '2023-12-01',
    title: 'Copy and paste measured Floor USF from one floor plan to another.',
    features: [
      'Copy and paste your measured Floor USF instead of redrawing USF per floor when you have similar floor plates.',
      'Upload plans with the same DPI (dots per inch) and your copied Floor USF will predict where to ‘paste in place’ on each floor.',
    ],
  },
  {
    date: '2023-11-02',
    title: 'Make bulk edits to space types from your Programming dashboards!',
    features: [
      'Update USF and Seat Count values for hundreds of the same space type all at once.',
      'Select which scenarios to apply these bulk updates to for significant time savings.',
    ],
  },
  {
    date: '2023-11-01',
    title: 'Sort worksheet rows in your Programming projects.',
    features: [
      'Sort space types in any order within all four space type categories.',
      'Simply drag the space type up and down on the worksheet.',
      'Before sorting summary rows, close all nested rows within that subcategory.',
    ],
  },
  {
    date: '2023-10-02',
    title:
      'A new file type is now available when exporting worksheets from your floor plans.',
    features: [
      'Download worksheets per floor from Existing Site Analysis projects as spreadsheets.',
      'XLSX files include all spaces and room data tagged on that floor.',
    ],
  },
  {
    date: '2023-10-01',
    title: 'Sort worksheet rows in your Existing Site Analysis projects.',
    features: [
      'Sort space types in any order within each of the four space type categories.',
      'You can also rearrange the sorting order of specific rooms within their space type.',
      'Simply drag the room or space type up and down on the ESA worksheet.',
    ],
  },
  {
    date: '2023-09-01',
    title:
      'We heard you! Apply client facing names to any space type in your Program scenarios.',
    features: [
      'Keep internal names for consistent data across projects but use client names to rename space types when needed per project.',
      'This new Client Names toggle allows you to view and export with either space type name.',
    ],
  },
  {
    date: '2023-08-02',
    title:
      'Select which floors to roll up into your Existing Site Analysis dashboards.',
    features: [
      'Multi-select is now available. View totals for selected floors across buildings.',
      'Update your floor selection and instantly recalculate dashboard metrics.',
    ],
  },
  {
    date: '2023-08-01',
    title:
      'Make bulk edits to space types from your Existing Site Analysis dashboards!',
    features: [
      'Update USF and Seat Count values for hundreds of the same space type all at once.',
      'Select which floors to apply these bulk updates to for significant time savings.',
    ],
  },
  {
    date: '2023-07-02',
    title:
      'Try out the new Save As feature and create Program Scenarios much faster!',
    features: [
      'Convert copies of scenarios created with one program calculator type and save them as another program type instantly.',
    ],
  },
  {
    date: '2023-07-01',
    title:
      'Updated Existing Site Analysis worksheets reveal more data and new subtotals.',
    features: [
      'Workstation and Private Office subtotal values are now calculated on new worksheet rows.',
      'Room Names are now visible. Use this field for people, departments, or even to note vacancies.',
    ],
  },
  {
    date: '2023-06-02',
    title:
      'Curious which Program Calculator to use for your programming analysis?',
    features: [
      'The basic requirements needed to start a program scenario are now listed per calculator to make it easier for you to decide.',
    ],
  },
  {
    date: '2023-06-01',
    title:
      'Enhanced calibration functionality is now available for your floor plans.',
    features: [
      'Look for the new calibration control button and green check indicator which allows you to instantly see if a floor has been calibrated.',
    ],
  },
  {
    date: '2023-05-01',
    title:
      'Check out the new filter button on your floor plans. View by space types.',
    features: [
      'See how space types are distributed at a glance per floor within each space category.',
      'Change any space type icon on your floor plans from the Program Summary page. Click on that icon to view the library of assets to select from.',
    ],
  },
  {
    date: '2023-04-02',
    title:
      'Copy and paste multiple space bubbles at once from one floor plan to another!',
    features: [
      'Copy or move multiple space bubbles between floors and buildings with our new multi-select tools. Bulk delete space bubbles too!',
      'Use our new keyboard shortcuts and save time.',
    ],
  },
  {
    date: '2023-04-01',
    title: 'Sort your existing buildings in any order.',
    features: [
      'Head over to Building Overview in your Building Details tab for a new building cards design.',
      'Drag and drop these new building cards into your desired order and watch them re-sort everywhere in your project.',
    ],
  },
  {
    date: '2023-03-02',
    title: 'Customize your Program Summary icons.',
    features: [
      'Select from a large library of workplace assets for any of your space types.',
      'Default back to the pre-selected icons at any time in your dashboards.',
      'Update an icon once and your selection will update everywhere in your project!',
    ],
  },
  {
    date: '2023-03-01',
    title: 'RSF calculations are now available in addition to USF metrics.',
    features: [
      'Add a rentable load factor to calculate RSF if needed for your analysis.',
      'A new RSF toggle allows you to turn these metrics on/off when viewing and downloading.',
    ],
  },
  {
    date: '2023-02-02',
    title: 'Role-based access controls have arrived!',
    features: [
      'Create teams, transfer project ownership, limit project access to view-only, and invite colleagues to collaborate.',
      'Search for projects, sort by clients, filter by industry, clone projects to create drafts, create templates for everyone, and so much more.',
    ],
  },
  {
    date: '2023-02-01',
    title:
      'Coming Soon... Password requirement enhancements to keep you secure.',
    features: [
      'Passwords will require a number, upper and lower case letters, and one special character.',
      'After five failed attempts, you will be locked out for five minutes on web and mobile.',
    ],
  },
  {
    date: '2023-01-01',
    title: 'Download Manager is now available for Programming projects.',
    features: [
      'Save templates for groups of files that you continually export at the same time for more efficient downloading.',
      'Select what type of file you would like to export: PNG or PDF.',
    ],
  },
];
